import styled from 'styled-components'
import FeedbackIcon from '@material-ui/icons/Feedback'

export const AppziIcon = styled(FeedbackIcon).attrs(() => ({
  color: 'primary'
}))``
